import React, { useEffect, useRef } from 'react';
import { genericErrorMessageStyles } from '../styles/genericErrorMessage';
import { useAppSelector } from '../../store/hook';
import { useTranslation } from 'react-i18next';
import { genericErrorProvider } from '../../store/providers/genericErrorProvider';
const GenericErrorMessage = (): React.JSX.Element => {
  const errorRef = useRef<HTMLDivElement>(null);
  const errorMsg = useAppSelector((state) => state.genericError);
  const { setGenericError } = genericErrorProvider();
  useEffect(() => {
    errorRef.current?.focus();
    setTimeout(() => {
      setGenericError('');
    }, 1000);
  }, [errorMsg]);

  const { t } = useTranslation();

  const { classes } = genericErrorMessageStyles();
  return (
    <>
      {errorMsg && (
        <div tabIndex={0} ref={errorRef} className={classes.errorMessage}>
          {t(errorMsg)}
        </div>
      )}
    </>
  );
};

export default GenericErrorMessage;
